import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustBanner from "@/components/site/TrustBanner";
import Services from "@/components/site/Services";
import Brands from "@/components/site/Brands";
import Realisations from "@/components/site/Realisations";
import Zones from "@/components/site/Zones";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import ContactForm from "@/components/site/ContactForm";
import MapCard from "@/components/site/MapCard";
import Footer from "@/components/site/Footer";
import EmergencyBanner from "@/components/site/EmergencyBanner";
import { COMPANY } from "@/data/content";
import { setSeo } from "@/lib/seo";

export default function Home() {
  useEffect(() => {
    setSeo({
      title:
        "Serrurier Lagny-sur-Marne (77) — Dépannage 24h/24 • " +
        COMPANY.phoneDisplay,
      description:
        "☎ " + COMPANY.phoneDisplay +
        " — Serrurier à Lagny-sur-Marne (77) : dépannage d'urgence 24h/24, ouverture de porte sans dégât, changement de serrure, blindage, coffre-fort. Intervention en 30 min à Thorigny, Pomponne, Saint-Thibault, Montévrain, Chessy. Devis gratuit.",
      canonical: "https://serrurier-lagny-sur-marne.com/",
    });
    // Remove any city-specific JSON-LD; homepage uses the static LocalBusiness.
    const stale = document.getElementById("ld-page");
    if (stale) stale.remove();
  }, []);

  return (
    <div className="App relative">
      <Navbar />
      <main>
        <Hero />
        <TrustBanner />
        <Services />
        <Brands />
        <Realisations />
        <Zones />
        <Testimonials />
        <FAQ />
        <ContactForm />
        <MapCard />
      </main>
      <Footer />
      <EmergencyBanner />
    </div>
  );
}
